import { useContext } from "react";
import ActivityLogTable from "../../components/ActivityLogTable";
import { useQueryHouseholdActivities } from "../../lib/activity-log";
import { HouseholdContext } from "./HouseholdInfo";

/**
 * Shows the loading state until the household is known, as the query's
 * `enabled: householdId > 0` does, and remounts the list per household (a React
 * `key`), so the entries read for one household are never shown under another.
 */
const HouseholdActivity = () => {
  const { household } = useContext(HouseholdContext);
  const householdId = household?.id ?? -1;

  return householdId > 0 ? (
    <HouseholdActivityOfHousehold key={householdId} householdId={householdId} />
  ) : (
    <ActivityLogTable isLoading={true} isError={false} activities={[]} />
  );
};

const HouseholdActivityOfHousehold = ({
  householdId,
}: {
  householdId: number;
}) => {
  const { isPending, isError, data } = useQueryHouseholdActivities(householdId);

  return (
    <ActivityLogTable
      isLoading={isPending}
      isError={isError}
      activities={data?.data ?? []}
    />
  );
};

export default HouseholdActivity;
